<script setup>
	import { DsText, DsButton, DsButtonGroup, DsIconButton } from '@coloplast/design-system';

	const props = defineProps({
		vm: {
			type: Object,
			required: true,
		},
		isModalOpen: {
			type: Boolean,
			default: false,
		}
	});

	const emit = defineEmits(['close-modal']);

	const closeModal = (closeModalValue = 'close') => {
		emit('close-modal', closeModalValue);
	};
</script>

<template>
	<div
		v-if="isModalOpen"
		class="c-modal-login-campaign__overlay"
	>
		<aside class="c-modal-login-campaign__wrapper">
			<DsIconButton
				type="button"
				aria-label="Close"
				icon-name="close"
				variant="ghost-neutral"
				size="md"
				class="c-modal-login-campaign__button-close"
				:click-handler="closeModal"
			/>
			<DsText
				v-if="vm.Headline"
				html-element="h3"
				text-type="heading-2xl"
				text-style="medium"
				class="c-modal-login-campaign__headline"
			>
				{{ vm.Headline }}
			</DsText>
			<DsText
				v-if="vm.Description"
				html-element="p"
				text-type="body-md"
				text-style="regular"
				class="c-modal-login-campaign__description"
			>
				<span v-html="vm.Description"></span>
			</DsText>
			<DsButtonGroup
				v-if="(vm.LoginButtonText && vm.LoginButtonUrl) || vm.RegisterAsGuestButtonText"
				button-size="md"
				mobile-direction="column"
			>
				<DsButton
					v-if="vm.LoginButtonText && vm.LoginButtonUrl"
					variant="primary"
					size="md"
					:href="vm.LoginButtonUrl"
					data-testid="login-button"
				>
					{{ vm.LoginButtonText }}
				</DsButton>
				<DsButton
					v-if="vm.RegisterAsGuestButtonText"
					variant="ghost-neutral"
					size="md"
					data-testid="register-button"
					:click-handler="() => closeModal('continue')"
				>
					{{ vm.RegisterAsGuestButtonText }}
				</DsButton>
			</DsButtonGroup>
		</aside>
	</div>
</template>
